webpackJsonp([246346688097926],{

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Changing the Port'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Webpack is configured to start the development server on port ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '3000'
	      ),
	      ' by default. That\'s what happens when you start the application using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm start\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to change the port for the development server, you can provide a different port using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm start -- --env.port=3001\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The command above would cause the development server to be served on port ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '3001'
	      ),
	      ' instead.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Relevant Section'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section of the Webpack config that controls this behavior is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      devServer: {\n        port: env.port || 3000,\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-development-port-js-2578274cc2d041bc4164.js